export const MAX_FILE_SIZE_MB = 5;
export const MAX_BREADCRUMBS_SIZE = 3;
export const CURRENCYVSSYMBOLMAP: { [key: string]: string } = {
  USD: '$',
  INR: '₹',
  AED: 'د.إ'
};

export const DASHBOARD_URL: { [key: string]: string } = {
  'ad-details': 'ancillaryAdDetails',
  'payment-breakdown': 'ancillaryPaymentBreakdown',
  'payment-status': 'ancillaryPaymentStatus',
  'user-profile': 'profile',
  verification: 'verification',
  newVerification: 'newVerification',
  'request-correction': 'requestCorrection',
  'appeal-request': 'appealRequest',
  'verification-details': 'verificationDetails',
  'manage-account': 'manageAccount',
  home: 'home',
  'account-option': 'account',
  'notification-category': 'notificationPreferences',
  email: 'email',
  sms: 'sms',
  pushNotification: 'pushNotification',
  transactions: 'transactions',
  services: 'services',
  category: 'services',
  'pricing-estimate': 'pricingDetails',
  'document-upload': 'documentUpload',
  'additional-components': 'documentUpload',
  'letter-of-auth': 'letterOfAuth',
  overview: 'documentUpload',
  'pricing-details': 'paymentDetails',
  'find-report': 'findReport',
  'fetch-report-details': 'findReport',
  'report-document-details': 'findReport',
  'existing-reports': 'findReport',
  'verify-report-details': 'findReport',
  'verification-insufficiency': 'insufficiency',
  'language-preference': 'languagePreference',
  vault: 'vault',
  'subscription-payment': 'subscription-payment',
  status: 'status',
  'validate-trueproof': 'validateTrueproof',
  'client-requirement-list-tab': 'applicationDetails',
  'select-issuers': 'selectIssuers',
  'select-documents': 'selectDocuments'
};

export const ATTRIBUTE_TYPE_KEY = 'AttributeType';

export const REDIRECT_TO_HOME_DELAY_TIME = 2 * 1000;

export const AVAILABLE_KEY = 'Available';

export const TRUE = 'true';
